<template>
	<div
		:class="[
			'card bg-white-base border',
			{ 'border-white-darker-4': !selected, 'border-ink-lighter-3': selected }
		]"
		:style="{ boxShadow: shadow }"
	>
		<!-- @slot Slot onde conteúdo do card é inserido -->
		<slot></slot>
	</div>
</template>

<script>
export default {
	name: 'b-card',
	props: {
		/**
		 * Se true aplica cor da borda de card selecionado
		 */
		selected: {
			type: Boolean,
			default: false
		}
	},
	computed: {
		shadow() {
			return this.selected
				? '0px 6px 10px 0 rgba(0, 0, 0, 0.24)'
				: '0px 2px 2px rgba(0, 0, 0, 0.141)';
		}
	}
};
</script>

<style lang="scss" scoped>
.card {
	border-radius: 5px;
}
</style>

<docs>
    Card

    A importação do arquivo abaixo é necessária para o funcionamento do componente:
    - colors-classes.scss

    Para a classe de padding do exemplo ser aplicada é necessário importar o arquivo:
    - spacing.scss

    ```js
    <b-card class="padding-normal"><p>Card exemplo</p></b-card>
    ```
</docs>
